import { BlockLoader } from './loading';

/** Centered "Loading…" state shown inside a page's content card.
 *
 * Extracted from TasksPage / LmsContentPage / LmsSessionsPage, where
 * this exact markup was the body of each page's `{loading ? (...)}` branch
 * inside the content `<section>`. The only thing that varied between pages was
 * the message string, so it is passed in as a prop. The `loading` conditional
 * stays in each page; only the identical inner markup lives here.
 * Drawn with the loading kit's ring; the padding (py-12) and the message are what
 * they always were. */
export function ContentLoadingState({ message }: { message: string }) {
  return <BlockLoader label={message} className="py-12" />;
}
